import React from 'react';
import PropTypes from 'prop-types';
import { FiMapPin } from 'react-icons/fi';
import styles from './searchInput.module.css';

const SearchItemRegion = ({ item, onSelect }) => {
  const onClick = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (item.display) {
      onSelect(item);
    } else {
      onSelect({
        ...item,
        type: 'vertex',
        label: '',
        metroRegion: item.metroRegion,
        id: '',
      });
    }
  };

  return (
    <div className={styles.search_item} onClick={onClick}>
      <FiMapPin className={styles.search_icon} />
      <div className={styles.search_item_value}>{item.display || item.metroRegion}</div>
    </div>
  );
};

SearchItemRegion.propTypes = {
  // id, metroRegion, displayValue
  item: PropTypes.object,
  onSelect: PropTypes.func,
};

export default SearchItemRegion;
